/** Query families that expose a placement status or status-dependent membership. */
export function isPlacementStatusQuery(queryKey: readonly unknown[]) {
  const path = queryKey[0];
  return Array.isArray(path) && ["placement", "application", "metrics", "finance"].includes(String(path[0]));
}
